import React from 'react';
import Head from 'next/head';
import { DefaultSeo } from 'next-seo';
import type { AppProps } from 'next/app';
import { store } from 'store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from 'hooks/useAuth';
import KeenTheme from 'styles/KeenTheme';
import { ErrorBoundary } from 'react-error-boundary';
import ApplicationError from 'components/Errors/ApplicationError';
import { logError } from 'libs/logger';
import faviconIcon from 'assets/icons/favicon.ico';
import CssBaseline from '@mui/material/CssBaseline';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';

require('typeface-yrsa');

const handleError = (error: Error, info: { componentStack: string }) => {
  logError(error, info);
};

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ThemeProvider theme={KeenTheme}>
      <ErrorBoundary FallbackComponent={ApplicationError} onError={handleError}>
        <CssBaseline />
        <Head>
          <title>Find a Psychic | Best Psychics | Keen</title>
          <link href={faviconIcon.src} rel="shortcut icon" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Head>
        <DefaultSeo
          title="Find a Psychic | Best Psychics | Keen"
          description="Psychics, Mediums and Tarot Readers. Get a Love and Relationship Psychic Reading Now via Phone or Chat. First 3 Minutes are Free!"
          canonical="https://www.keen.com"
          openGraph={{
            type: 'website',
            locale: 'en_US',
            url: 'https://www.keen.com',
            site_name: 'Keen'
          }}
          twitter={{
            handle: '@keen',
            site: '@keen',
            cardType: 'summary_large_image'
          }}
        />
        <React.StrictMode>
          <Provider store={store}>
            <AuthProvider>
              <Component {...pageProps} />
            </AuthProvider>
          </Provider>
        </React.StrictMode>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default MyApp;
